'use client';

import { SkeletonBar } from '@petsmart-ui/sparky';
import { useMedia } from 'react-use';

import { BREAKPOINTS, useUserSession } from '@libs/common-next';

import { AccountPopover, Authenticated, Unauthenticated } from './components';
import { useAccountSessionLoading } from './use-account-session-loading';

import './account.scss';

const DESKTOP_MEDIA_QUERY = `(min-width: ${BREAKPOINTS.lg}px) and (hover: hover) and (pointer: fine)`;

export function Account() {
    const { isAuthenticated } = useUserSession();
    const isAccountDataLoading = useAccountSessionLoading();
    const isDesktop = useMedia(DESKTOP_MEDIA_QUERY, false);
    const variant = isDesktop ? 'desktop' : 'mobile';

    if (isAccountDataLoading) {
        return <SkeletonBar className="account__loader" />;
    }

    if (isAuthenticated) {
        return <Authenticated variant={variant} />;
    }

    return (
        <AccountPopover
            key={variant} // Remount only when Account switches between Desktop and Mobile behavior.
            variant={variant}
            accountHref="/sign-in"
        >
            {({ close }) => <Unauthenticated onAction={close} />}
        </AccountPopover>
    );
}
